import { Card, Table, TableBody, Box, Typography, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow } from 'app/components';
import clsx from 'clsx';
import React, { useState } from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },

  imageContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },

  image: {
    maxWidth: '100%',
    maxHeight: 400,
    borderRadius: 8,
    border: '1px solid #ddd',
  },

  tabs: {
    marginTop: theme.spacing(1),
  },
}));

const formatGender = (g) => {
  if (g === 'M') return 'Male';
  if (g === 'F') return 'Female';
  return g || '-';
};

const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString();
};

const RegtankDocumentTable = ({ documents = {}, className }) => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const docInfo = documents?.documentInfo || {};
  const ocr = documents?.ocrResults || {};
  const idvV1Info = documents?.idvV1Info || {};

  const extensions = idvV1Info?.documentExtensions || [];

  // 🔥 Build tab list
  const tabs = [
    { label: 'Front', value: docInfo.frontDocumentUrl },
    { label: 'Back', value: docInfo.backDocumentUrl },

    // 🔥 Only include useful extensions
    ...extensions
      .filter((ext) => ['Portrait', 'Barcode', 'Fingerprint', 'Ghost portrait'].includes(ext.key))
      .map((ext) => ({
        label: ext.key,
        value: ext.value,
      })),
  ].filter((t) => t.value); // remove empty

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>ID Photo</TitleField>

      {/* 🔥 Tabs */}
      <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" className={classes.tabs}>
        {tabs.map((t, i) => (
          <Tab key={i} label={t.label} />
        ))}
      </Tabs>

      {/* 🔥 Image Viewer */}
      <Box className={classes.imageContainer}>{tabs[tab]?.value && <img src={tabs[tab].value} alt={tabs[tab].label} className={classes.image} />}</Box>

      {/* 🔥 OCR TABLE */}
      <Table>
        <TableBody>
          <DataRow name="Document Type" value={docInfo.documentType || '-'} />
          <DataRow name="Country" value={ocr.idIssuingCountry || '-'} />

          <DataRow name="Full Name" value={ocr.fullName || '-'} />
          <DataRow name="ID Number" value={ocr.idNumber || '-'} />
          <DataRow name="Date of Birth" value={formatDate(ocr.dateOfBirth)} />
          <DataRow name="Gender" value={formatGender(ocr.gender)} />
          <DataRow name="Address" value={ocr.address || '-'} />

          <DataRow name="OCR Status" value={ocr.status === 'SUCCESS' ? <span style={{ color: 'green', fontWeight: 'bold' }}>SUCCESS</span> : ocr.status || '-'} />
        </TableBody>
      </Table>
    </Card>
  );
};

export default RegtankDocumentTable;
